<div class="main-banner-episodes-area" style="background-image: url(../../../../assets/images/main-banner/banner-bg-2.jpg);">
    <div class="container">
        <div class="main-banner-episodes-content">
            <h1>AfroTech Connect</h1>
            <p>Mettre en lumière les avancées technologiques en Afrique </p>
            
            <ul class="banner-social">
                <li>
                    <a href="https://whatsapp.com/channel/0029VahtDxc6hENtQQWQRk17" target="_blank">
                        <i class="ri-whatsapp-line exception-icon"></i>
                    </a>
                </li>
                <li>
                    <a href="https://open.spotify.com/show/2ASTbhkADWhD2w0eDPWtkI?si=4c6c29047e8149ed" target="_blank">
                        <i class="flaticon-spotify"></i>
                    </a>
                </li>
                <li>
                    <a href="https://x.com/afrotech_hub" target="_blank">
                        <i class="flaticon-twitter"></i>
                    </a>
                </li>
                <li>
                    <a href="https://www.facebook.com/afrotechub/" target="_blank">
                        <i class="flaticon-facebook"></i>
                    </a>
                </li>
                <li>
                    <a href="https://www.instagram.com/afrotech_hub" target="_blank">
                        <i class="flaticon-instagram"></i>
                    </a>
                </li>
                <li>
                    <a href="https://www.youtube.com/channel/UC60eYhuHatzPs-qTtyudIFg?sub_confirmation=1" target="_blank">
                        <i class="ri-youtube-line exception-icon"></i>
                    </a>
                </li>
                <li>
                    <a href="https://www.linkedin.com/company/afrotechhub/" target="_blank">
                        <i class="ri-linkedin-fill exception-icon"></i>
                    </a>
                </li>
            </ul>
        </div>
        <div class="banner-episodes-slides">
            <owl-carousel-o [options]="bannerEpisodesSlides">
                <ng-template carouselSlide *ngFor="let content of data">
                    <div class="banner-episodes-card">
                        <a routerLink="/season-list">
                            <img [src]="content.attributes.speaker_image.data.attributes.url" alt="image">
                        </a>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>